export enum PlanningStatus {
  UNPLANNED = 'UNPLANNED',
  PARTIALLY_PLANNED = 'PARTIALLY_PLANNED',
  PLANNED = 'PLANNED',
}
